export type BrandId = 'WTW' | 'LEA'

export interface BrandConfig {
  id: BrandId
  siteName: string
  tagline: string
  footerCredit: string
  aboutRoute: string
  partnersRoute: string
  metaDescription: string
  baseUrl: string
  contactEmail?: string
  contactPhone?: string
  logoPath?: string
  ogImagePath?: string
  accentHex?: string
  accent2Hex?: string
}

const WTW: BrandConfig = {
  id: 'WTW',
  siteName: 'Welcome to Wichita',
  tagline: 'Events • Arts • Music • Food • Community',
  footerCredit: 'A joint publication by Zippy Technologies LLC and Little Eddie Audio (Edwin Perry).',
  aboutRoute: '/about-wichita',
  partnersRoute: '/partners',
  metaDescription:
    "Welcome to Wichita — the city's hub for live events, arts, music, food, and community.",
  baseUrl: 'https://welcometowichita.com',
  contactEmail: 'hello@welcometowichita.com',
  logoPath: '/favicon.svg',
  ogImagePath: '/favicon.svg',
  accentHex: '#0ea5e9',
  accent2Hex: '#22c55e',
}

const LEA: BrandConfig = {
  id: 'LEA',
  siteName: 'Little Eddie Audio',
  tagline: 'Performance • Production • Real Music',
  footerCredit: 'Little Eddie Audio — founded by Edwin Perry. Platform by Zippy Technologies LLC.',
  aboutRoute: '/about-little-eddie',
  partnersRoute: '/partners',
  metaDescription:
    'Little Eddie Audio — Wichita performance, production, reviews, and stage insights by Edwin Perry.',
  baseUrl: 'https://littleeddieaudio.com',
  contactEmail: 'hello@littleeddieaudio.com',
  contactPhone: '(316) 555-EDDIE',
  logoPath: '/favicon.svg',
  ogImagePath: '/favicon.svg',
  accentHex: '#7c3aed',
  accent2Hex: '#06b6d4',
}

export function getBrandForHost(hostname: string): BrandConfig {
  const host = hostname.toLowerCase()
  if (host.includes('welcometowichita')) return WTW
  if (host.includes('littleeddie')) return LEA
  return WTW
}


